import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import AdStats from "./views/pages/AdStats.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    }
];


routes = Vue.cmsRouter.setRoutes(routes);

// Add custom grid childRoutes
const gridRoute = routes.find(route => route.name === 'grid');
// Add custom add stats route
gridRoute.children.unshift({
    path: 'ad-stats/:objectId',
    name: 'ad-stats',
    components: {
        childview: AdStats,
    },
    beforeEnter: (to, from, next) => {
        if (to.params.bundle !== 'ad') {
            next('/*');
        }

        next();
    }
});

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
